// extracted by mini-css-extract-plugin
module.exports = {"checkout":"BatchAndRenewalNotification_checkout__2iJVz","accordion":"BatchAndRenewalNotification_accordion__2WxwZ"};